import getNodeName from "./getNodeName.js";
export default function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/dom-utils/isTableElement.js
// module id = 1689
// module chunks = 22